import { useEffect } from "react";
import { message, Modal } from "antd";

export default function NotificationManager() {
  const [messageApi, messageContext] = message.useMessage();
  const [modalApi, modalContext] = Modal.useModal();

  useEffect(() => {
    const buildHandler = (type, defaultTitle) => {
      return (content, optOrDuration) => {
        const isNumber = typeof optOrDuration === "number";

        const options = isNumber ? {} : optOrDuration || {};
        const duration = isNumber ? optOrDuration : options.duration;
        const modal = options.modal ?? false;

        const text =
          typeof content === "string" ? content : content?.toString() || "";

        // --- MENSAJE NORMAL ---
        if (!modal) {
          messageApi[type](text, duration);
          return;
        }

        // --- MODAL ---
        const modalInstance = modalApi[type]({
          title: options.title || defaultTitle,
          content: text,
          centered: true,
          ...options, // permite width, footer, etc.
        });

        // Duration para cerrar modal automáticamente
        if (duration && typeof duration === "number") {
          setTimeout(() => {
            modalInstance.destroy?.();
          }, duration * 1000);
        }
      };
    };

    const api = {
      success: buildHandler("success", "Éxito"),
      error: buildHandler("error", "Error"),
      info: buildHandler("info", "Información"),
      warning: buildHandler("warning", "Advertencia"),

      loading(content, duration) {
        messageApi.loading(content, duration);
      },

      destroy() {
        messageApi.destroy();
      }
    };

    window.messageApi = api;
  }, [messageApi, modalApi]);

  return (
    <>
      {messageContext}
      {modalContext}
    </>
  );
}